export default {
  data() {
    return {
      fill1: 'none',
      fill2: 'none',
      fill3: 'none',
      fill4: 'none',
      fill5: 'none',
      fill6: 'none',
      fill7: 'none',
      fill8: 'none',
      fill9: 'none',
      fill10: 'none',
      fill11: 'none',
      fill12: 'none',
      fill13: 'none',
      fill14: 'none',
      fill15: 'none',
      fill16: 'none',
      fill17: 'none',
      fill18: 'none',
      fill19: 'none',
      fill20: 'none',
      fill21: 'none',
      fill22: 'none',
      fill23: 'none',
      fill24: 'none',
      fill25: 'none',
      fill26: 'none',
      fill27: 'none',
      fill28: 'none',
      fill29: 'none',
      fill30: 'none',
      fill31: 'none',
      fill32: 'none',
      fill33: 'none',
      fill34: 'none',
      fill35: 'none',
      fill36: 'none',
      fill37: 'none',
      fill38: 'none',
      fill39: 'none',
      fill40: 'none',
      fill41: 'none',
      fill42: 'none',
      fill43: 'none',
      fill44: 'none',
    };
  },
  methods: {
    partClick: function (item) {
      if (this.hasClick) {
        if (item == 1) {
          this.fill1 = '#0A6ADA';
          this.$emit('frontPartClick', item);
        } else if (item == 2) {
          this.fill2 = '#0A6ADA';
          this.$emit('frontPartClick', item);
        } else if (item == 3) {
          this.fill3 = '#0A6ADA';
          this.$emit('frontPartClick', item);
        } else if (item == 4) {
          this.fill4 = '#0A6ADA';
          this.$emit('frontPartClick', item);
        } else if (item == 5) {
          this.fill5 = '#0A6ADA';
          this.$emit('frontPartClick', item);
        } else if (item == 6) {
          this.fill6 = '#0A6ADA';
          this.$emit('frontPartClick', item);
        } else if (item == 7) {
          this.fill7 = '#0A6ADA';
          this.$emit('frontPartClick', item);
        } else if (item == 8) {
          this.fill8 = '#0A6ADA';
          this.$emit('frontPartClick', item);
        } else if (item == 9) {
          this.fill9 = '#0A6ADA';
          this.$emit('frontPartClick', item);
        } else if (item == 10) {
          this.fill10 = '#0A6ADA';
          this.$emit('frontPartClick', item);
        } else if (item == 11) {
          this.fill11 = '#0A6ADA';
          this.$emit('frontPartClick', item);
        } else if (item == 12) {
          this.fill12 = '#0A6ADA';
          this.$emit('frontPartClick', item);
        } else if (item == 13) {
          this.fill13 = '#0A6ADA';
          this.$emit('frontPartClick', item);
        } else if (item == 14) {
          this.fill14 = '#0A6ADA';
          this.$emit('frontPartClick', item);
        } else if (item == 15) {
          this.fill15 = '#0A6ADA';
          this.$emit('frontPartClick', item);
        } else if (item == 16) {
          this.fill16 = '#0A6ADA';
          this.$emit('frontPartClick', item);
        } else if (item == 17) {
          this.fill17 = '#0A6ADA';
          this.$emit('frontPartClick', item);
        } else if (item == 18) {
          this.fill18 = '#0A6ADA';
          this.$emit('frontPartClick', item);
        } else if (item == 19) {
          this.fill19 = '#0A6ADA';
          this.$emit('frontPartClick', item);
        } else if (item == 20) {
          this.fill20 = '#0A6ADA';
          this.$emit('frontPartClick', item);
        } else if (item == 21) {
          this.fill21 = '#0A6ADA';
          this.$emit('frontPartClick', item);
        } else if (item == 22) {
          this.fill22 = '#0A6ADA';
          this.$emit('frontPartClick', item);
        } else if (item == 23) {
          this.fill23 = '#0A6ADA';
          this.$emit('frontPartClick', item);
        } else if (item == 24) {
          this.fill24 = '#0A6ADA';
          this.$emit('frontPartClick', item);
        } else if (item == 25) {
          this.fill25 = '#0A6ADA';
          this.$emit('frontPartClick', item);
        } else if (item == 26) {
          this.fill26 = '#0A6ADA';
          this.$emit('frontPartClick', item);
        } else if (item == 27) {
          this.fill27 = '#0A6ADA';
          this.$emit('frontPartClick', item);
        } else if (item == 28) {
          this.fill28 = '#0A6ADA';
          this.$emit('frontPartClick', item);
        } else if (item == 29) {
          this.fill29 = '#0A6ADA';
          this.$emit('frontPartClick', item);
        } else if (item == 30) {
          this.fill30 = '#0A6ADA';
          this.$emit('frontPartClick', item);
        } else if (item == 31) {
          this.fill31 = '#0A6ADA';
          this.$emit('frontPartClick', item);
        } else if (item == 32) {
          this.fill32 = '#0A6ADA';
          this.$emit('frontPartClick', item);
        } else if (item == 33) {
          this.fill33 = '#0A6ADA';
          this.$emit('frontPartClick', item);
        } else if (item == 34) {
          this.fill34 = '#0A6ADA';
          this.$emit('frontPartClick', item);
        } else if (item == 35) {
          this.fill35 = '#0A6ADA';
          this.$emit('frontPartClick', item);
        } else if (item == 36) {
          this.fill36 = '#0A6ADA';
          this.$emit('frontPartClick', item);
        } else if (item == 37) {
          this.fill37 = '#0A6ADA';
          this.$emit('frontPartClick', item);
        } else if (item == 38) {
          this.fill38 = '#0A6ADA';
          this.$emit('frontPartClick', item);
        } else if (item == 39) {
          this.fill39 = '#0A6ADA';
          this.$emit('frontPartClick', item);
        } else if (item == 40) {
          this.fill40 = '#0A6ADA';
          this.$emit('frontPartClick', item);
        } else if (item == 41) {
          this.fill41 = '#0A6ADA';
          this.$emit('frontPartClick', item);
        } else if (item == 42) {
          this.fill42 = '#0A6ADA';
          this.$emit('frontPartClick', item);
        } else if (item == 43) {
          this.fill43 = '#0A6ADA';
          this.$emit('frontPartClick', item);
        } else if (item == 44) {
          this.fill44 = '#0A6ADA';
          this.$emit('frontPartClick', item);
        }
      }
    },
    clearPart: function (item) {
      if (item == 1) {
        this.fill1 = 'none';
      } else if (item == 2) {
        this.fill2 = 'none';
      } else if (item == 3) {
        this.fill3 = 'none';
      } else if (item == 4) {
        this.fill4 = 'none';
      } else if (item == 5) {
        this.fill5 = 'none';
      } else if (item == 6) {
        this.fill6 = 'none';
      } else if (item == 7) {
        this.fill7 = 'none';
      } else if (item == 8) {
        this.fill8 = 'none';
      } else if (item == 9) {
        this.fill9 = 'none';
      } else if (item == 10) {
        this.fill10 = 'none';
      } else if (item == 11) {
        this.fill11 = 'none';
      } else if (item == 12) {
        this.fill12 = 'none';
      } else if (item == 13) {
        this.fill13 = 'none';
      } else if (item == 14) {
        this.fill14 = 'none';
      } else if (item == 15) {
        this.fill15 = 'none';
      } else if (item == 16) {
        this.fill16 = 'none';
      } else if (item == 17) {
        this.fill17 = 'none';
      } else if (item == 18) {
        this.fill18 = 'none';
      } else if (item == 19) {
        this.fill19 = 'none';
      } else if (item == 20) {
        this.fill20 = 'none';
      } else if (item == 21) {
        this.fill21 = 'none';
      } else if (item == 22) {
        this.fill22 = 'none';
      } else if (item == 23) {
        this.fill23 = 'none';
      } else if (item == 24) {
        this.fill24 = 'none';
      } else if (item == 25) {
        this.fill25 = 'none';
      } else if (item == 26) {
        this.fill26 = 'none';
      } else if (item == 27) {
        this.fill27 = 'none';
      } else if (item == 28) {
        this.fill28 = 'none';
      } else if (item == 29) {
        this.fill29 = 'none';
      } else if (item == 30) {
        this.fill30 = 'none';
      } else if (item == 31) {
        this.fill31 = 'none';
      } else if (item == 32) {
        this.fill32 = 'none';
      } else if (item == 33) {
        this.fill33 = 'none';
      } else if (item == 34) {
        this.fill34 = 'none';
      } else if (item == 35) {
        this.fill35 = 'none';
      } else if (item == 36) {
        this.fill36 = 'none';
      } else if (item == 37) {
        this.fill37 = 'none';
      } else if (item == 38) {
        this.fill38 = 'none';
      } else if (item == 39) {
        this.fill39 = 'none';
      } else if (item == 40) {
        this.fill40 = 'none';
      } else if (item == 41) {
        this.fill41 = 'none';
      } else if (item == 42) {
        this.fill42 = 'none';
      } else if (item == 43) {
        this.fill43 = 'none';
      } else if (item == 44) {
        this.fill44 = 'none';
      }
    },
    colorPart: function (item) {
      if (item == 1) {
        this.fill1 = '#0A6ADA';
      } else if (item == 2) {
        this.fill2 = '#0A6ADA';
      } else if (item == 3) {
        this.fill3 = '#0A6ADA';
      } else if (item == 4) {
        this.fill4 = '#0A6ADA';
      } else if (item == 5) {
        this.fill5 = '#0A6ADA';
      } else if (item == 6) {
        this.fill6 = '#0A6ADA';
      } else if (item == 7) {
        this.fill7 = '#0A6ADA';
      } else if (item == 8) {
        this.fill8 = '#0A6ADA';
      } else if (item == 9) {
        this.fill9 = '#0A6ADA';
      } else if (item == 10) {
        this.fill10 = '#0A6ADA';
      } else if (item == 11) {
        this.fill11 = '#0A6ADA';
      } else if (item == 12) {
        this.fill12 = '#0A6ADA';
      } else if (item == 13) {
        this.fill13 = '#0A6ADA';
      } else if (item == 14) {
        this.fill14 = '#0A6ADA';
      } else if (item == 15) {
        this.fill15 = '#0A6ADA';
      } else if (item == 16) {
        this.fill16 = '#0A6ADA';
      } else if (item == 17) {
        this.fill17 = '#0A6ADA';
      } else if (item == 18) {
        this.fill18 = '#0A6ADA';
      } else if (item == 19) {
        this.fill19 = '#0A6ADA';
      } else if (item == 20) {
        this.fill20 = '#0A6ADA';
      } else if (item == 21) {
        this.fill21 = '#0A6ADA';
      } else if (item == 22) {
        this.fill22 = '#0A6ADA';
      } else if (item == 23) {
        this.fill23 = '#0A6ADA';
      } else if (item == 24) {
        this.fill24 = '#0A6ADA';
      } else if (item == 25) {
        this.fill25 = '#0A6ADA';
      } else if (item == 26) {
        this.fill26 = '#0A6ADA';
      } else if (item == 27) {
        this.fill27 = '#0A6ADA';
      } else if (item == 28) {
        this.fill28 = '#0A6ADA';
      } else if (item == 29) {
        this.fill29 = '#0A6ADA';
      } else if (item == 30) {
        this.fill30 = '#0A6ADA';
      } else if (item == 31) {
        this.fill31 = '#0A6ADA';
      } else if (item == 32) {
        this.fill32 = '#0A6ADA';
      } else if (item == 33) {
        this.fill33 = '#0A6ADA';
      } else if (item == 34) {
        this.fill34 = '#0A6ADA';
      } else if (item == 35) {
        this.fill35 = '#0A6ADA';
      } else if (item == 36) {
        this.fill36 = '#0A6ADA';
      } else if (item == 37) {
        this.fill37 = '#0A6ADA';
      } else if (item == 38) {
        this.fill38 = '#0A6ADA';
      } else if (item == 39) {
        this.fill39 = '#0A6ADA';
      } else if (item == 40) {
        this.fill40 = '#0A6ADA';
      } else if (item == 41) {
        this.fill41 = '#0A6ADA';
      } else if (item == 42) {
        this.fill42 = '#0A6ADA';
      } else if (item == 43) {
        this.fill43 = '#0A6ADA';
      } else if (item == 44) {
        this.fill44 = '#0A6ADA';
      }
    },
    clearAllParts: function () {
      this.fill1 = 'none';
      this.fill2 = 'none';
      this.fill3 = 'none';
      this.fill4 = 'none';
      this.fill5 = 'none';
      this.fill6 = 'none';
      this.fill7 = 'none';
      this.fill8 = 'none';
      this.fill9 = 'none';
      this.fill10 = 'none';
      this.fill11 = 'none';
      this.fill12 = 'none';
      this.fill13 = 'none';
      this.fill14 = 'none';
      this.fill15 = 'none';
      this.fill16 = 'none';
      this.fill17 = 'none';
      this.fill18 = 'none';
      this.fill19 = 'none';
      this.fill20 = 'none';
      this.fill21 = 'none';
      this.fill22 = 'none';
      this.fill23 = 'none';
      this.fill24 = 'none';
      this.fill25 = 'none';
      this.fill26 = 'none';
      this.fill27 = 'none';
      this.fill28 = 'none';
      this.fill29 = 'none';
      this.fill30 = 'none';
      this.fill31 = 'none';
      this.fill32 = 'none';
      this.fill33 = 'none';
      this.fill34 = 'none';
      this.fill35 = 'none';
      this.fill36 = 'none';
      this.fill37 = 'none';
      this.fill38 = 'none';
      this.fill39 = 'none';
      this.fill40 = 'none';
      this.fill41 = 'none';
      this.fill42 = 'none';
      this.fill43 = 'none';
      this.fill44 = 'none';
    },
    setColorToEachPart: function (item, color) {
      if (item == 1) {
        this.fill1 = color;
      } else if (item == 2) {
        this.fill2 = color;
      } else if (item == 3) {
        this.fill3 = color;
      } else if (item == 4) {
        this.fill4 = color;
      } else if (item == 5) {
        this.fill5 = color;
      } else if (item == 6) {
        this.fill6 = color;
      } else if (item == 7) {
        this.fill7 = color;
      } else if (item == 8) {
        this.fill8 = color;
      } else if (item == 9) {
        this.fill9 = color;
      } else if (item == 10) {
        this.fill10 = color;
      } else if (item == 11) {
        this.fill11 = color;
      } else if (item == 12) {
        this.fill12 = color;
      } else if (item == 13) {
        this.fill13 = color;
      } else if (item == 14) {
        this.fill14 = color;
      } else if (item == 15) {
        this.fill15 = color;
      } else if (item == 16) {
        this.fill16 = color;
      } else if (item == 17) {
        this.fill17 = color;
      } else if (item == 18) {
        this.fill18 = color;
      } else if (item == 19) {
        this.fill19 = color;
      } else if (item == 20) {
        this.fill20 = color;
      } else if (item == 21) {
        this.fill21 = color;
      } else if (item == 22) {
        this.fill22 = color;
      } else if (item == 23) {
        this.fill23 = color;
      } else if (item == 24) {
        this.fill24 = color;
      } else if (item == 25) {
        this.fill25 = color;
      } else if (item == 26) {
        this.fill26 = color;
      } else if (item == 27) {
        this.fill27 = color;
      } else if (item == 28) {
        this.fill28 = color;
      } else if (item == 29) {
        this.fill29 = color;
      } else if (item == 30) {
        this.fill30 = color;
      } else if (item == 31) {
        this.fill31 = color;
      } else if (item == 32) {
        this.fill32 = color;
      } else if (item == 33) {
        this.fill33 = color;
      } else if (item == 34) {
        this.fill34 = color;
      } else if (item == 35) {
        this.fill35 = color;
      } else if (item == 36) {
        this.fill36 = color;
      } else if (item == 37) {
        this.fill37 = color;
      } else if (item == 38) {
        this.fill38 = color;
      } else if (item == 39) {
        this.fill39 = color;
      } else if (item == 40) {
        this.fill40 = color;
      } else if (item == 41) {
        this.fill41 = color;
      } else if (item == 42) {
        this.fill42 = color;
      } else if (item == 43) {
        this.fill43 = color;
      } else if (item == 44) {
        this.fill44 = color;
      }
    },
  },
};
